module.exports = __webpack_public_path__ + "img/twitter-x.69b7e34b.svg";